import React from "react";
import classNames from "classnames";

import { setSelectedItemInLocalStorage } from "utils/products";
import { Product } from "resources/AudiotekaApi";

import { getProductsLimit } from "./getProductsLimit";
import css from "./teaser-grid.module.scss";

type Props = {
  products: Product[];
  listData?: {
    id: string;
    name: string;
  };
  setProductsPerPage?: (value: number) => void;
  children?: React.ReactNode;
  renderTeaser: (product: Product, onClick: () => void) => React.ReactNode;
};

/**
 * @deprecated Use components/product-grid instead
 */
export const TeaserGrid = ({ products, listData, setProductsPerPage, renderTeaser, children }: Props) => {
  const gridRef = React.useRef(null);

  React.useEffect(() => {
    setProductsPerPage?.(getProductsLimit(gridRef, 5));
  }, [setProductsPerPage]);

  const onClick = (product: Product) => {
    if (listData) {
      setSelectedItemInLocalStorage(product.id, listData);
    }
  };

  return (
    <div
      className={classNames(css.teaserGrid, { "adtk-item-list": listData })}
      data-list-id={listData?.id}
      data-list-name={listData?.name}
      ref={gridRef}
    >
      {products.map((product) => renderTeaser(product, () => onClick(product)))}
      {children}
    </div>
  );
};
